module.exports = __webpack_public_path__ + "static/05-c2b065fa59d2b2a043a15f17f957456f.jpg";